import { createContext, useContext } from 'react';
import type { SimplesNacionalGrupo } from '@/services/SimplesNacional/GestaoDocumentos/api/ListaDocumentosSimplesApi';

export type TipoDocumento = 'entradas' | 'saidas';

export interface FiltroState {
  modelo: string;
  status: string;
}

export interface FiltroBase {
  entrada_saida: number;
  cnpj_contribuinte: string;
  data_emissao_de: string;
  data_emissao_ate: string;
  status: string;
}

export interface GestaoDocumentosContextData {
  cnpjSelecionado: string | null;

  tabAtiva: TipoDocumento;
  setTabAtiva: (tab: TipoDocumento) => void;

  filtroPendente: FiltroState;
  setFiltroPendente: React.Dispatch<React.SetStateAction<FiltroState>>;
  filtroAplicado: FiltroState;
  aplicarFiltros: () => void;
  resetarFiltros: () => void;

  filtroBase: FiltroBase;

  filtrosVisiveis: boolean;
  setFiltrosVisiveis: (v: boolean) => void;

  uploadAberto: boolean;
  abrirUpload: () => void;
  fecharUpload: () => void;
  historicoAberto: boolean;
  abrirHistorico: () => void;
  fecharHistorico: () => void;

  grupos: SimplesNacionalGrupo[];
  totalEntradas: number;
  totalSaidas: number;
  isLoadingEntradas: boolean;
  isLoadingSaidas: boolean;
  isError: boolean;
}

export const GestaoDocumentosContext = createContext<GestaoDocumentosContextData | undefined>(
  undefined
);

export function useGestaoDocumentos(): GestaoDocumentosContextData {
  const ctx = useContext(GestaoDocumentosContext);
  if (!ctx) {
    throw new Error('useGestaoDocumentos deve ser usado dentro de GestaoDocumentosProvider');
  }
  return ctx;
}
